enum CollageImageEnum {
  LargeTopSmall3ColBottomRight = 1,
  LargeTopSmall2ColBottomRight,
  LargeTopSmall2ColBottomLeft,
  LargeTopSmall4ColBottomRight,
  LargeTopSmall3ColBottomLeft
}

export default CollageImageEnum;
